import React, {useRef} from 'react';
import './footer_not_login.css'
import {NavLink, useHistory} from 'react-router-dom'

import axios from 'axios';
const Footer_not_login=()=>{
    const history=useHistory()

    
    const modalref=useRef(null);
    console.log(window.location.href);

    const checkActive = (match, location) => {
        //some additional logic to verify you are in the home URI
        if(!location) return false;
        const {pathname} = location;
        console.log(pathname);
        return pathname === "/";
    }
    return(
        <div style={{
            // position:'fixed',
            left:0,
            bottom:0,
            width:'100%',
            backgroundColor:'#00172d',
            color:'#FFF',
            // zIndex:100,
            marginTop:10,
            paddingTop:5,
            paddingBottom:5
        }}>
        <div style={{marginLeft:"2vw"}}>
         <button ref={modalref} onClick={() => history.goBack()}  style={{border:"none", backgroundColor:"rgb(0, 23, 45)"  }}>
         <img src="https://img.icons8.com/officel/344/long-arrow-left.png" alt="backbtn.png" height="40vh" width="40vh"/>

         </button>
      </div>
            <div className="grid-container_footer">
                <div  className="grid-item_footer">
                    <div>
                        <h4 style={{
                            fontWeight:'bold'
                        }}>ADDRESS</h4>
                    </div>
                    <div>
                        <span>1245, 27th Main Rd, Sector 2, PWD Quaters, BDA Layout, Somasundrapalya, Bengaluru, Karnataka 560102</span>
                    </div>
                </div>
                <div  className="grid-item_footer">
                    <div>
                        <h4 style={{
                            fontWeight:'bold'
                        }}>Pages</h4>
                    </div>
                    <div>
                        <ul style={{
                            flexDirection:'row',
                            display:'flex',
                            flexWrap:'wrap',
                            margin:0, padding:0
                        }}>
                            <li>
                                <NavLink onClick={()=>{
                                    axios.get('/currentuser')
                                    .then(res=>{
                                        if(res.data.error){
                    
                                        }else{ 
                                            history.replace("/");  
                                            history.go(0)
                                        }
                                    })
                                }} isActive={checkActive} style={{
                                    textDecoration:'none', fontWeight:'bold',
                                    color:'#FFF'
                                }}  activeStyle={{ color: "green" }} to='/'>HOME</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={()=>{
                                    axios.get('/currentuser')
                                    .then(res=>{
                                        if(res.data.error){
                    
                                        }else{ 
                                            history.replace("/");  
                                            history.go(0)
                                        }
                                    })
                                }} style={{
                                    textDecoration:'none', fontWeight:'bold',
                                    color:'#FFF'
                                }} activeStyle={{ color: "green" }} to='/about'>ABOUT</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={()=>{
                                    axios.get('/currentuser')
                                    .then(res=>{
                                        if(res.data.error){
                    
                                        }else{ 
                                            history.replace("/");  
                                            history.go(0)
                                        }
                                    })
                                }} style={{
                                    textDecoration:'none', fontWeight:'bold',
                                    color:'#FFF'
                                }} activeStyle={{ color: "green" }} to='/contact'>CONTACT</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={()=>{
                                    axios.get('/currentuser')
                                    .then(res=>{
                                        if(res.data.error){
                    
                                        }else{ 
                                            history.replace("/");  
                                            history.go(0)
                                        }
                                    })
                                }} style={{
                                    textDecoration:'none', fontWeight:'bold',
                                    color:'#FFF'
                                }} activeStyle={{ color: "green" }} to='/login'>LOG IN</NavLink>
                            </li>
                            <li>
                                <NavLink onClick={()=>{
                                    axios.get('/currentuser')
                                    .then(res=>{
                                        if(res.data.error){
                    
                                        }else{   
                                            history.replace("/");
                                            history.go(0)
                                        }
                                    })
                                }} style={{
                                    textDecoration:'none', fontWeight:'bold',
                                    color:'#FFF'
                                }} activeStyle={{ color: "green" }} to='/signup'>SIGN UP</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <div  className="grid-item_footer" style={{textAlign:'center'}}>
                    <div>
                        <h4 style={{
                            fontWeight:'bold'
                        }}>Connect</h4>
                    </div>
                    <div>
                       <ul style={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'row',
                    margin:0, padding:0}}>
                            <li>
                                <a href='https://www.facebook.com/SuperSeva/' target='_blank'>
                                    <i style={{
                                        fontSize:20,
                                        fontWeight:'bold'
                                    }} className="fa fa-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a href='https://twitter.com/super_seva' target='_blank'>
                                    <i style={{
                                        fontSize:20,
                                        fontWeight:'bold'
                                    }} className="fa fa-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a href='https://www.linkedin.com/company/494136/admin/' target='_blank'>
                                    <i style={{
                                        fontSize:20,
                                        fontWeight:'bold'
                                    }} className="fa fa-linkedin"></i>
                                </a>
                            </li>
                       </ul>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default Footer_not_login;